/// <reference path="_references.ts"/>

module App.Forms {
	angular
		.module('forms', [])
		.config(['$stateProvider', ($stateProvider: ng.ui.IStateProvider) => {
			$stateProvider
				.state('zipSolutions.forms', {
					url: 'forms',
					data: {
						title: 'Forms'
					},
					views: {
						'content@': {
							controller: 'FormListController',
							controllerAs: 'ctrl',
							templateUrl: 'html/forms/form-list.tpl.html'
						}
					}
				})
				.state('zipSolutions.forms.create', {
					url: '/new?item',
					data: {
						title: 'Create Form'
					},
					views: {
						'content@': {
							controller: 'FormCreateController',
							controllerAs: 'ctrl',
							templateUrl: 'html/forms/form-details.tpl.html'
						}
					}
				})
				.state('zipSolutions.forms.edit', {
					url: '/{id:int}?item',
					data: {
						title: 'Edit Form'
					},
					views: {
						'content@': {
							controller: 'FormEditController',
							controllerAs: 'ctrl',
							templateUrl: 'html/forms/form-details.tpl.html'
						}
					}
				})
		}])
		.service('FormService', FormService)
		.controller('FormListController', FormListController)
		.controller('FormCreateController', FormCreateController)
		.controller('FormEditController', FormEditController)
		.directive('input', () => {
			return {
		        require: '?ngModel',
		        link: (scope, elem, attrs, ngModel) => {
		            if (ngModel && attrs.type === 'number') {
		                ngModel.$formatters.push((value: any) => parseFloat(value));
		            }
		        }
		    };
		})
        .filter('htmlLinky', ['$filter', ($filter: ng.IFilterService) => {
            return (v: string, ...args: any) =>
                (<(v: string, ...args: any) => string>$filter('linky'))(v.replace(/</g, ' <'), ...args)
                    .replace(/ &lt;/g, '<')
                    .replace(/&gt;/g, '>')
                    .replace(/&amp;/g, '&');
        }]);
}
